import React, { useState, } from 'react';
import moment from 'moment';
//import { DateTimePicker } from 'material-ui-pickers';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import IPosModal from "../../IPosModal";
import {OrderType} from '../../constants/orderTypes';

import './order-type.scss';

const OrderTypeSwitcher = ({ t, locale, orderType = OrderType.ASAP, setOrderType, setOrderDate, orderDateTime, editable, branchInfo, currentUiLanguageId}) => {
  const [selectedDate, handleDateChange] = useState(orderDateTime || new Date());
  // const [orderType, setOrderType] = useState(null);

  const updateDateTime = (dateTime) => {
    handleDateChange(dateTime);
    setOrderDate(dateTime);
  };

  const GetLanguage = () => {
    if (currentUiLanguageId === 2) {
      return "he-HE";
    } else if (currentUiLanguageId === 3) {
      return "ru-RU";
    }
    return "en-EN";
  };

  const clearDeliveryDateTime = (dateTime) => {
    setOrderType(OrderType.ASAP);
    handleDateChange(null);
    setOrderDate(null);
  };

  const changeOrderType = () => {
    if (!editable) {
      return false;
    }

    IPosModal.chooseTimeModal(
      {
        branchInfo: branchInfo,
        currentUiLanguageId: currentUiLanguageId,
        onOk: (day) => {
          setOrderType(OrderType.FUTURE);
          handleDateChange(day);
          setOrderDate(day);
        },
        onClose: () => {
          setOrderType(OrderType.ASAP);
          handleDateChange(null);
          setOrderDate(null);
        },
      },
      {}
    );

    // if (orderType === OrderType.ASAP) {
    //   setOrderType(OrderType.FUTURE);
    //   setOrderDate(moment().format());
    // } else {
    //   setOrderType(OrderType.ASAP);
    //   setOrderDate(null);
    // }
  };

  return (
    <div className={ 'order-type' }>
      <MuiPickersUtilsProvider utils={ MomentUtils } locale={ locale }>
        <div className={ 'switch-btn' } onClick={ changeOrderType }>
          <FontAwesomeIcon icon="calendar-alt" className={ '' } />
        </div>

        <div className={ 'order-type-label' }>
          { orderType === OrderType.ASAP && (
            <div className={ 'now-label' } onClick={ changeOrderType }>
              { t('order.order_type_now') }
            </div>
          )}

          { orderType === OrderType.FUTURE && (
            <div className={ 'future-label' }>
              {/* <DateTimePicker
                autoOk
                ampm={ false }
                value={ selectedDate }
                onChange={ updateDateTime }
                // label="Delivery Date Time"
                onError={ console.log }
                disablePast
                disabled={ !editable }
              /> */}
              { selectedDate && (
                <div className={ 'selected-datetime' }> {selectedDate.toLocaleString(GetLanguage(), {
                  weekday: 'short',
                  day: '2-digit',
                  month: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit'
                }).replace('.', '/')} </div>
              )

              }
              { editable && (
                <div className={'clear-future-label'} onClick={ clearDeliveryDateTime }>
                  <FontAwesomeIcon icon="times"  />
                </div>
              )}

            </div>
          )}

        </div>

      </MuiPickersUtilsProvider>
    </div>
  );
};

export default OrderTypeSwitcher;
